import { push } from 'react-router-redux';
import SubmissionError from 'redux-form/lib/SubmissionError';
import unescaper from 'anchor-server-common/utilities/unescaper';
import {
  fetchSegments,
  submitUpdateEpisodeFormEvent,
} from './partnerAnalytics';

export const FETCHING_EPISODE = '@@episode/FETCHING_EPISODE';
export const TOGGLE_IS_SHORT_METADATA_FORM_SHOWING =
  '@@episode/TOGGLE_IS_SHORT_METADATA_FORM_SHOWING';
export const RECEIVE_EPISODE = '@@episode/RECEIVE_EPISODE';
export const RECEIVE_AVAILABLE_SEGMENTS =
  '@@episode/RECEIVE_AVAILABLE_SEGMENTS';
export const SET_IS_DELETING = '@@episode/SET_IS_DELETING';
export const SET_IS_RENAMING = '@@episode/SET_IS_RENAMING';
export const SET_TITLE = '@@episode/SET_TITLE';
export const ADD_SEGMENT = '@@episode/ADD_SEGMENT';
export const ADD_SEGMENT_DONE = '@@episode/ADD_SEGMENT_DONE';
export const REMOVE_SEGMENT = '@@episode/REMOVE_SEGMENT';
export const REMOVE_SEGMENT_DONE = '@@episode/REMOVE_SEGMENT_DONE';
export const SET_IS_PUBLISHING_TO_PODCAST =
  '@@episode/SET_IS_PUBLISHING_TO_PODCAST';
export const SET_HAS_PODCAST_EPISODE = '@@episode/SET_HAS_PODCAST_EPISODE';

const emptyArray = [];
const emptyObject = {};

const initialState = {
  availableSegments: emptyArray, // until we fix this issue, we cannot repeat a segment across episodes
  episodeId: null,
  isFetching: false,
  isDeleting: false,
  isRenaming: false,
  isPublishingToPodcast: false,
  hasPodcastEpisode: false,
  hasPodcast: false,
  segments: emptyArray,
  segmentsBeingAdded: emptyObject,
  segmentsBeingRemoved: emptyObject,
  title: null,
  isShortMetadataFormShowing: false,
};

// reducers

function segmentReducer(state = emptyObject, action) {
  switch (action.type) {
    case RECEIVE_EPISODE:
    case RECEIVE_AVAILABLE_SEGMENTS: {
      const { caption } = state;
      if (caption) {
        return {
          ...state,
          caption: unescaper(caption),
        };
      }
      return state;
    }
    default:
      return state;
  }
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ADD_SEGMENT:
      return {
        ...state,
        segmentsBeingAdded: addAndCopy(
          state.segmentsBeingAdded,
          action.stationAudioId
        ),
      };
    case ADD_SEGMENT_DONE: {
      return {
        ...state,
        segmentsBeingAdded: removeAndCopy(
          state.segmentsBeingAdded,
          action.stationAudioId
        ),
      };
    }
    case REMOVE_SEGMENT:
      return {
        ...state,
        segmentsBeingRemoved: addAndCopy(
          state.segmentsBeingRemoved,
          action.stationAudioId
        ),
      };
    case REMOVE_SEGMENT_DONE: {
      return {
        ...state,
        segmentsBeingRemoved: removeAndCopy(
          state.segmentsBeingRemoved,
          action.stationAudioId
        ),
      };
    }
    case FETCHING_EPISODE: {
      const { isFetching } = action;
      return {
        ...state,
        isFetching,
      };
    }
    case RECEIVE_AVAILABLE_SEGMENTS: {
      return {
        ...state,
        availableSegments: action.availableSegments.map(s =>
          segmentReducer(s, action)
        ),
      };
    }
    case RECEIVE_EPISODE:
      return {
        ...state,
        episodeId: action.episodeId,
        segments: action.segments.map(s => segmentReducer(s, action)),
        title: unescaper(action.title),
        hasPodcastEpisode: action.hasPodcastEpisode,
        hasPodcast: action.hasPodcast,
      };

    case SET_TITLE:
      return {
        ...state,
        title: unescaper(action.title),
      };
    case SET_IS_RENAMING:
      return {
        ...state,
        isRenaming: action.isRenaming,
      };
    case SET_IS_DELETING:
      return {
        ...state,
        isDeleting: action.isDeleting,
      };
    case SET_IS_PUBLISHING_TO_PODCAST:
      return {
        ...state,
        isPublishingToPodcast: action.isPublishingToPodcast,
      };
    case SET_HAS_PODCAST_EPISODE:
      return {
        ...state,
        hasPodcastEpisode: action.hasPodcastEpisode,
      };
    case TOGGLE_IS_SHORT_METADATA_FORM_SHOWING:
      return {
        ...state,
        isShortMetadataFormShowing: !state.isShortMetadataFormShowing,
      };
    default:
      return state;
  }
}

// action creators
function receiveEpisode({
  title,
  episodeId,
  segments,
  hasPodcastEpisode,
  hasPodcast,
}) {
  return {
    type: RECEIVE_EPISODE,
    episodeId,
    segments,
    title,
    hasPodcastEpisode,
    hasPodcast,
  };
}

function receiveAvailableSegments(
  allAvailableSegments = [],
  segmentsInEpisodes = []
) {
  const segmentIdsUsed = segmentsInEpisodes.map(s => s.stationAudioId);
  const availableSegments = allAvailableSegments.filter(
    s => segmentIdsUsed.indexOf(s.stationAudioId) === -1
  );
  return {
    type: RECEIVE_AVAILABLE_SEGMENTS,
    availableSegments,
  };
}

function fetchingEpisode(isFetching) {
  return {
    type: FETCHING_EPISODE,
    isFetching,
  };
}
export function toggleIsShortMetadataFormShowing() {
  return {
    type: TOGGLE_IS_SHORT_METADATA_FORM_SHOWING,
  };
}
export function setIsDeleting(isDeleting) {
  return {
    type: SET_IS_DELETING,
    isDeleting,
  };
}
export function setIsRenaming(isRenaming) {
  return {
    type: SET_IS_RENAMING,
    isRenaming,
  };
}
export function setIsPublishingToPodcast(isPublishingToPodcast) {
  return {
    type: SET_IS_PUBLISHING_TO_PODCAST,
    isPublishingToPodcast,
  };
}

function addSegment(stationAudioId) {
  return {
    type: ADD_SEGMENT,
    stationAudioId,
  };
}

function addSegmentDone(stationAudioId) {
  return {
    type: ADD_SEGMENT_DONE,
    stationAudioId,
  };
}

function removeSegment(stationAudioId) {
  return {
    type: REMOVE_SEGMENT,
    stationAudioId,
  };
}

function removeSegmentDone(stationAudioId) {
  return {
    type: REMOVE_SEGMENT_DONE,
    stationAudioId,
  };
}

function setTitle(title) {
  return {
    type: SET_TITLE,
    title,
  };
}

function setHasPodcastEpisode(hasPodcastEpisode) {
  return {
    type: SET_HAS_PODCAST_EPISODE,
    hasPodcastEpisode,
  };
}

// thunks

export function addSegmentToEpisode(stationAudioId) {
  return (dispatch, getState) => {
    dispatch(addSegment(stationAudioId));
    const {
      episode: { episodeId },
    } = getState();
    fetch(`/api/user/episodes/${episodeId}`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify({
        stationAudioId,
      }),
    })
      .then(response => {
        if (response.status === 200) {
          const {
            episode: { episodeId },
          } = getState();
          dispatch(fetchEpisode(episodeId));
        }
      })
      .then(always, always);

    function always() {
      dispatch(addSegmentDone(stationAudioId));
    }
  };
}

export function removeSegmentFromEpisode(stationAudioId) {
  return (dispatch, getState) => {
    dispatch(removeSegment(stationAudioId));
    const {
      episode: { episodeId },
    } = getState();
    fetch(`/api/user/episodes/${episodeId}/segments/${stationAudioId}`, {
      method: 'DELETE',
      credentials: 'same-origin',
    })
      .then(response => {
        if (response.status === 200) {
          const {
            episode: { episodeId },
          } = getState();
          dispatch(fetchEpisode(episodeId));
        }
      })
      .then(always, always);

    function always() {
      dispatch(removeSegmentDone(stationAudioId));
    }
  };
}

export function fetchEpisode(episodeId) {
  return (dispatch, getState) => {
    dispatch(fetchingEpisode(true));
    // borrow segments from partner analytics or fetch
    const {
      partnerAnalytics: { segments },
    } = getState();
    let allSegmentsPromise;
    if (!segments.length) {
      allSegmentsPromise = dispatch(fetchSegments());
    } else {
      allSegmentsPromise = Promise.resolve(segments);
    }
    const episodePromise = fetch(`/api/user/episodes/${episodeId}`, {
      credentials: 'same-origin',
    })
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        return response;
      })
      .then(responseJson => {
        if (responseJson.status && responseJson.status !== 200) {
          if (responseJson.status === 401) {
            // not logged in
            return dispatch(push('/login'));
          }
          // e.g. no permissions (403)
          return dispatch(push('/404'));
        }
        const { episode, hasPodcastEpisode, hasPodcast } = responseJson;
        dispatch(receiveEpisode(episode));
        return episode;
      });

    // TODO: once we fix this bug we don't need this filter
    const segmentsInEpisodesPromise = fetch('/api/user/segments/inepisodes', {
      credentials: 'same-origin',
    })
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        return response;
      })
      .then(responseJson => {
        if (responseJson.status && responseJson.status !== 200) {
          if (responseJson.status === 401) {
            // not logged in
            return dispatch(push('/login'));
          }
          // e.g. no permissions (403)
          return dispatch(push('/404'));
        }
        const { segmentsInEpisodes } = responseJson;
        return segmentsInEpisodes;
      });

    return Promise.all([
      allSegmentsPromise,
      episodePromise,
      segmentsInEpisodesPromise,
    ])
      .then(([allSegmentsResult, episodeResult, segmentsInEpisodesResult]) => {
        dispatch(
          receiveAvailableSegments(allSegmentsResult, segmentsInEpisodesResult)
        );
      })
      .then(always, always);

    function always() {
      dispatch(fetchingEpisode(false));
    }
  };
}

export function deleteEpisode() {
  return (dispatch, getState) => {
    const {
      episode: { episodeId },
    } = getState();
    fetch(`/api/user/episodes/${episodeId}`, {
      method: 'DELETE',
      credentials: 'same-origin',
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(push('/partner/episodes'));
        }
      })
      .then(always, always);

    function always() {
      dispatch(setIsDeleting(false));
    }
  };
}

export function submitUpdateEpisodeForm(data) {
  return (dispatch, getState) => {
    const {
      episode: { episodeId },
    } = getState();
    dispatch(submitUpdateEpisodeFormEvent());
    fetch(`/api/user/episodes/${episodeId}`, {
      method: 'PUT',
      credentials: 'same-origin',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data),
    })
      .then(response => {
        const { status } = response;
        if (status === 400) {
          throw new SubmissionError({
            _error: 'There was a problem with this title.',
          });
        }
        // e.g. no permissions (403)
        if (status === 403) {
          dispatch(push('/404'));
          return;
        }
        if (status === 401) {
          dispatch(push('/login'));
          return;
        }
        // set the title instead of re-fetching the episode
        dispatch(setTitle(data.title));
      })
      .then(always, always);

    function always() {
      dispatch(setIsRenaming(false));
    }
  };
}

export function publishEpisodeToPodcast() {
  return (dispatch, getState) => {
    const {
      episode: { episodeId },
    } = getState();
    dispatch(setIsPublishingToPodcast(true));
    fetch(`/api/user/episodes/${episodeId}/publishtopodcast`, {
      method: 'POST',
      credentials: 'same-origin',
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(setHasPodcastEpisode(true));
        }
      })
      .then(always, always);

    function always() {
      dispatch(setIsPublishingToPodcast(false));
    }
  };
}

// misc
// errors shape matches values input
export function validate(values) {
  const errors = {};
  if (!values.title) {
    errors.title = 'A title is required';
  }
  return errors;
}

function addAndCopy(object, id) {
  const copy = { ...object };
  copy[id] = true;
  return copy;
}
function removeAndCopy(object, id) {
  const copy = { ...object };
  delete copy[id];
  return copy;
}
